<template>
  <div>
    <!-- bar -->
    <van-nvabar title="预订"
                left-arrow
                :placeholder="true"
                fixed
                @click-left="onClickLeft">
      <template #right>
        <!-- <van-icon name="search"
                    size="18" /> -->
      </template>
    </van-nvabar>
    <!-- 选择套餐 -->
    <van-radio-group v-model="selectPkgId">
      <van-cell-group>
        <div v-for="sku_item in sku_list"
             :key="sku_item.sku_id">
          <van-cell :title="sku_item.sku_name"
                    clickable
                    @click="selectPackage(sku_item.sku_id)">
            <template #right-icon>
              <van-radio :name="sku_item.sku_id" />
            </template>
          </van-cell>
        </div>
      </van-cell-group>
    </van-radio-group>
    <!-- 选择出发日期 -->
    <div class="pd10">订单信息：</div>
    <van-field label="订单编号:">
      <template #input>
        <!-- 随机数+年月日+时分秒 -->
        {{inputBookingNum}}
      </template>
    </van-field>
    <van-cell title="选择出行日期"
              :value="choiceDate"
              @click="showCalendar = true" />

    <van-calendar v-model="showCalendar"
                  @confirm="onConfirm"
                  :show-confirm="false" />
    <!-- 选择时间/场次 -->
    <van-field label="场次/时间:">
      <template #input>
        <time-input ref="TimeInput"
                    @timeChange="timeChange"
                    :select_time="selectTime"
                    :time_list="sku_times"></time-input>

      </template>
    </van-field>
    <!-- 规格数量 -->
    <div class="pd10">数量</div>
    <div v-for="type_item in price_type_list"
         :key="type_item.id">
      <van-field :label="type_item.type">
        <template #input>
          <van-stepper min="0"
                       v-model="type_item.num" />

        </template>
      </van-field>
    </div>

    <!-- 联系人信息 -->
    <div class="pd10">联系人信息：</div>
    <van-field label="联系人:"
               v-model="inputContact">
    </van-field>
    <van-field label="电话:"
               v-model="inputPhone">
      <template #input>

      </template>
    </van-field>
    <!-- 其他信息 -->
    <div class="pd10">其他信息：</div>
    <van-field label="来源:"
               v-model="inputSource">
    </van-field>
    <van-field label="备注:"
               v-model="inputBookingRemark">

    </van-field>
    <!-- 提交 -->
    <div class="pd10"></div>
    <div style="margin:10px">
      <van-button color="#ff5421"
                  @click="makeReviseSubmitBtn"
                  round
                  block>提交</van-button>
    </div>
    <div style="padding-bottom:50px"></div>
  </div>
</template>

<script>
import { Cell, CellGroup } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Calendar } from 'vant'
import { Field } from 'vant'
import { Button } from 'vant'
import { Stepper } from 'vant'
import { Notify } from 'vant'
import { NavBar } from 'vant'

// 测试区域
import TimeInput from '../../../components/common/input/TimeInput'

export default {
  name: 'm_make_resveration',
  components: {
    'van-nvabar': NavBar,
    'van-cell': Cell,
    'van-radio': Radio,
    'van-cell-group': CellGroup,
    'van-radio-group': RadioGroup,
    'van-calendar': Calendar,
    'van-field': Field,
    'time-input': TimeInput,
    'van-button': Button,
    'van-stepper': Stepper,
    [Notify.Component.name]: Notify.Component,
  },
  data() {
    return {
      // 数据
      spu_id: '',
      spu_title: '',
      sku_list: [],
      showCalendar: false,
      optionsTime: '',
      // 选择的套餐
      selectPkgId: '',
      //
      inputContact: null,
      inputPhone: '',
      inputEmail: null,
      // 其他项
      voucher_id: '', // 系统单号
      choiceDate: '', //选择日期
      selectTime: '', //选择的 时间/场次
      template_items: [], // 附加项的信息 与返现
      price_type_list: [
        { type: '成人', type_info: '', num: 0, id: 1 },
        { type: '儿童', type_info: '', num: 0, id: 2 },
      ],
      sku_additions_list: [],
      inputSource: '',
      inputBookingNum: '',
      inputBookingRemark: '',
      // 填充用
      sku_times: [
        { value: '06:00' },
        { value: '06:30' },
        { value: '07:00' },
        { value: '07:30' },
        { value: '08:00' },
        { value: '08:30' },
        { value: '09:00' },
        { value: '09:30' },
        { value: '10:00' },
        { value: '10:30' },
        { value: '11:00' },
        { value: '12:00' },
        { value: '13:00' },
        { value: '13:30' },
        { value: '14:00' },
        { value: '14:30' },
        { value: '15:00' },
        { value: '16:00' },
        { value: '17:00' },
      ],
    }
  },
  props: {},
  created() {
    this.spu_id = this.$route.query.spu_id

    this.getBookingNumber()
  },
  mounted() {
    this.getProductInfo(this.spu_id)
  },
  methods: {
    selectPackage(item) {
      this.selectPkgId = item
    },
    getProductInfo(spu_id) {
      this.$http.get(`/product/get_product?spu_id=${spu_id}`).then((res) => {
        // console.log(res)
        this.sku_list = res.data.data.skus
        this.spu_id = spu_id
        this.spu_title = res.data.data.spu_name
      })
    },
    // 选择日期
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    },
    onConfirm(date) {
      this.showCalendar = false
      this.choiceDate = this.formatDate(date)
    },
    // 时间改变时,给父组件赋值。
    timeChange(value) {
      this.selectTime = value

      // console.log("时间" + this.selectTime);
    },
    // 提交订单
    makeReviseSubmitBtn() {
      // 判断订单信息是填写，
      if (this.inputContact === null) {
        Notify({ type: 'warning', message: '请填写联系人' })
        return
      }
      if (this.inputContact === '') {
        Notify({ type: 'warning', message: '请填写联系人' })
        return
      }
      if (this.inputPhone === null) {
        Notify({ type: 'warning', message: '请填写联系方式' })
        return
      }

      if (this.inputPhone === '') {
        Notify({ type: 'warning', message: '请填写联系方式' })
        return
      } else if (!/^1[3456789]\d{9}$/.test(this.inputPhone)) {
        Notify({ type: 'warning', message: '电话格式正确' })
        return
      }
      if (this.selectPkgId === '') {
        Notify({ type: 'warning', message: '请选择该项目需要预定的套餐' })
        return
      } else if (this.choiceDate === '') {
        Notify({ type: 'warning', message: '请选择该订单需要预定的日期' })
        return
      } else if (this.$refs.TimeInput.time === '') {
        Notify({ type: 'warning', message: '请选择该订单需要预定的时间' })
        return
      } else if (this.price_type_list) {
        let price_item = this.price_type_list
        let num_list = []
        for (let i of price_item) {
          num_list.push(i.num)
        }
        // every（）方法 ，检测数组所有元素是否都符合指定条件
        // some 方法,方法用于检测数组中的元素是否满足指定条件（函数提供）有就为真
        // 如果都等于0 或则都等于undefine。则 不合格
        // console.log(num_list);
        let is_empty = num_list.some((item) => item !== undefined)
        // console.log(is_empty);
        if (is_empty === false) {
          Notify({ type: 'warning', message: '未填写预定数量' })

          return
        }
        let is_empty_zero = num_list.some((item) => item !== 0)
        if (is_empty_zero === false) {
          Notify({ type: 'warning', message: '未填写预定数量' })

          return
        }
      }
      if (this.inputContact === null) {
        Notify({ type: 'warning', message: '请填写联系人' })

        return
      }
      if (this.template_items === []) {
        Notify({ type: 'warning', message: '请填行程信息' })
      }

      // 获取需要的数据，组成json 发送给后台。
      let bookingInfo = {}

      bookingInfo.booking_no = this.voucher_id // 系统单号
      bookingInfo.spu_id = this.spu_id
      bookingInfo.spu_name = this.spu_title
      bookingInfo.sku_id = this.selectPkgId
      bookingInfo.sku_name = this.sku_name
      bookingInfo.join_date = this.choiceDate
      bookingInfo.join_time = this.$refs.TimeInput.time
      bookingInfo.num_list = this.price_type_list
      bookingInfo.select_addition_dict = this.sku_additions_list
      bookingInfo.contact_name = this.inputContact
      bookingInfo.contact_phone = this.inputPhone
      bookingInfo.contact_email = this.inputEmail
      bookingInfo.source_from = this.inputSource
      bookingInfo.source_booking_id = this.inputBookingNum
      bookingInfo.remark = this.inputBookingRemark
      bookingInfo.template_info = this.template_items
      // 提交数据 终止 测试
      // console.log(bookingInfo)
      // return

      // 提交的订单信息
      this.$http.post('/booking/new-order', bookingInfo).then((res) => {
        const { errmsg, errno } = res.data
        console.log(bookingInfo)
        console.log(res)
        if (errno == '0') {
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.dialogReviseBooking = false
          this.selectPkgId = ''
          this.choiceData = ''
          this.$refs.TimeInput.time = ''
          this.price_type_list = [
            { type: '成人', type_info: '', num: 0, id: 1 },
            { type: '儿童', type_info: '', num: 0, id: 2 },
          ]
          this.inputContact = null
          // this.selectAdditionId = [];
          this.inputPhone = ''
          this.inputEmail = ''
          this.inputPickUp = ''
          this.inputSource = ''
          this.inputBookingNum = ''
          this.inputBookingRemark = ''
          this.template_items = []

          // 跳转到订单列表
          this.$router.push({ path: '/booking_list/sys_m' })
        } else if (errno == '4004') {
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        } else if (errno == '4003') {
          // 是否修改联系人姓名
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    onClickLeft() {
      this.$router.push({ path: `/m_product_list` })
    },
    //
    getBookingNumber() {
      let randomNum
      let date = new Date()

      var Year = 0
      var Month = 0
      var Day = 0
      var Hour = 0
      var Minutes = 0
      var Second = 0
      var CurrentDate = ''
      //初始化时间
      Year = date.getFullYear() //ie火狐下都可以
      Month = date.getMonth() + 1
      Day = date.getDate()
      Hour = date.getHours()
      Minutes = date.getMinutes()
      Second = date.getSeconds()
      CurrentDate += Year
      // 月份
      if (Month >= 10) {
        CurrentDate += Month
      } else {
        CurrentDate += '0' + Month
      }
      // 日期
      if (Day >= 10) {
        CurrentDate += Day
      } else {
        CurrentDate += '0' + Day
      }
      // 小时
      if (Hour >= 10) {
        CurrentDate += Hour
      } else {
        CurrentDate += '0' + Hour
      }
      // 分钟
      if (Minutes >= 10) {
        CurrentDate += Minutes
      } else {
        CurrentDate += '0' + Minutes
      }
      // 秒
      if (Second >= 10) {
        CurrentDate += Second
      } else {
        CurrentDate += '0' + Second
      }

      console.log('当前日期：', CurrentDate)

      // 生成随机数
      do randomNum = Math.floor(Math.random() * 10000)
      while (randomNum < 1000)

      this.inputBookingNum = randomNum + CurrentDate
    },
  },
}
</script>

<style>
</style>